module.exports = __webpack_public_path__ + "static/media/tick.79e708a1.svg";